import * as _CreateDialog from '../plugins/CreateDialog/index.js';
import * as _authentication from '../plugins/authentication/index.js';
import * as _const from '../plugins/const.js';
import * as _date from '../plugins/date.js';
import * as _filter from '../plugins/filter.js';
import * as _libTrack from '../plugins/libTrack.js';
import * as _loadScript from '../plugins/loadScript.js';
import * as _lodash from '../plugins/lodash.js';
import * as _maskerConfig from '../plugins/maskerConfig.js';
import * as _pageInit from '../plugins/pageInit.js';
import * as _perfMoniter from '../plugins/perfMoniter/index.js';
import * as _polyfill from '../plugins/polyfill/index.js';
import * as _resetMessage from '../plugins/resetMessage.js';
import * as _resetNotification from '../plugins/resetNotification.js';
import * as _syncLoading from '../plugins/syncLoading.js';
import * as _syncRoute from '../plugins/syncRoute.js';
import * as _ui from '../plugins/ui/index.js';
import * as _updateCheck from '../plugins/updateCheck/index.js';
import * as _userActivityTracker from '../plugins/userActivityTracker.js';

const events = {};

addPlugin([
  _CreateDialog,
  _authentication,
  _const,
  _date,
  _filter,
  _libTrack,
  _loadScript,
  _lodash,
  _maskerConfig,
  _pageInit,
  _perfMoniter,
  _polyfill,
  _resetMessage,
  _resetNotification,
  _syncLoading,
  _syncRoute,
  _ui,
  _updateCheck,
  _userActivityTracker
]);

export function applyPlugin(name, ...data) {
  if (events[name]) {
    return events[name].map(callback => callback(...data));
  }
  return [];
}

export function applyAsyncPlugin(name, ...data) {
  if (events[name]) {
    const asyncs = events[name].map(callback => callback(...data));
    return Promise.all(asyncs);
  }
  return Promise.resolve();
}

export function reducePlugin(name, data) {
  if (events[name]) {
    return events[name].reduce((pre, callback) => callback(pre), data);
  }
  return data;
}

export function addPlugin(...plugins) {
  plugins = Array.isArray(plugins[0]) ? plugins[0] : plugins;
  plugins.reduce(mergeEvents, events);
}

export function log(...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args);
  }
}

export function warn(...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(...args);
  }
}

export function error(...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.error(...args);
  }
}

function mergeEvents(memo, plugin) {
  if (plugin) {
    const exported = plugin.default || plugin;
    if (typeof exported === 'object' && !(exported instanceof Array)) {
      Object.entries(exported).forEach(([key, callback]) => {
        if (!memo[key]) {
          memo[key] = [];
        }
        if (typeof callback === 'function') {
          memo[key].push(callback);
        }
      });
    }
  }
  return memo;
}
